import React from 'react';
import { css } from 'styled-components';
import Media from 'react-media';
import FormError from 'components/common/FormError';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';
import MediaBorders from 'constants/media-borders';
import { applyStyles } from 'util/helpers';

const Input = ({ input, meta, type, ...inputProps }) => (
  <input
    {...input}
    {...inputProps}
    className={meta.error && meta.touched ? 'has-error' : ''}
    onBlur={() => {
      inputProps.onBlur && inputProps.onBlur(input.value);
      input.onBlur();
    }}
    onChange={event => {
      input.onChange(event.nativeEvent.target.value);
      inputProps.onChange &&
        inputProps.onChange(event.nativeEvent.target.value);
    }}
    onKeyDown={event => {
      inputProps.onKeyDown && inputProps.onKeyDown(event);
    }}
    type={type || 'text'}
  />
);

const PCInputContainer = ({ className, notes, meta, ...input }) => (
  <div className={className}>
    <div className="flex-container">
      <Input meta={meta} {...input} />
      {notes && (
        <ul className="notes">
          {notes.map((note, index) => (
            <li key={index}>{note}</li>
          ))}
        </ul>
      )}
    </div>
    <FormError {...meta} />
  </div>
);

const SPInputContainer = ({ className, meta, notes, ...input }) => (
  <div className={className}>
    <Input meta={meta} {...input} />
    <FormError {...meta} />
    {notes && (
      <ul className="notes">
        {notes.map((note, index) => (
          <li key={index}>{note}</li>
        ))}
      </ul>
    )}
  </div>
);

const commonStyle = css`
  input {
    max-width: 382px;
    width: 100%;
    height: 40px;
    padding: 0 16px 0 8px;
    background-color: ${Colors.white1};
    color: ${Colors.black1};
    border: 0;
    border-radius: 4px;
    box-shadow: inset 0 0 0 1px ${Colors.gray2};
    outline: none;

    // safari でのみ文字が折り返されるため
    word-break: normal;

    &::placeholder {
      color: ${Colors.gray2};
      opacity: 1;
    }

    &.has-error {
      background-color: ${Colors.orange2};
      box-shadow: inset 0 0 0 4px ${Colors.orange1};
    }

    &:disabled {
      background-color: ${Colors.gray4};
      color: ${Colors.gray2};
    }
  }

  .notes {
    padding: 0;
    margin: 0;
    list-style: none;

    li {
      color: ${Colors.black1};
      text-indent: -1.25em;
      padding-left: 1.25em;
    }
  }
`;

const pcStyle = css`
  input {
    ${FontStyles.text8};
  }

  .flex-container {
    display: flex;
    align-items: center;
  }

  .notes {
    margin-left: 16px;

    li {
      ${FontStyles.text12};
    }
  }
`;

const spStyle = css`
  input {
    ${FontStyles.text6};
  }

  .notes {
    margin-top: 8px;

    li {
      ${FontStyles.text8};
    }
  }
`;

const StyledPCInputContainer = applyStyles(PCInputContainer)(
  commonStyle,
  pcStyle
);
const StyledSPInputContainer = applyStyles(SPInputContainer)(
  commonStyle,
  spStyle
);

const InputContainer = ({ input, meta, inputProps }) => (
  <Media
    query={`(min-width: ${MediaBorders.umedium})`}
    children={matches =>
      matches ? (
        <StyledPCInputContainer input={input} meta={meta} {...inputProps} />
      ) : (
        <StyledSPInputContainer input={input} meta={meta} {...inputProps} />
      )
    }
  />
);

export default InputContainer;



// WEBPACK FOOTER //
// ./src/components/common/TextField/components/InputContainer.js